module.exports = __webpack_public_path__ + "static/redot3-07dc2d71fb6659b2213bfbb83f583f5b.gif";